import { render } from "./RegisterResource.vue?vue&type=template&id=5be55b87"
import script from "./RegisterResource.vue?vue&type=script&lang=js"
export * from "./RegisterResource.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__